import mySqlToLocal from "./mySqlToLocal"

const calculateSlots = (session) => {
  if (!session.slot_duration || session.slot_duration <= 0) {
    return [];
  }
  
  const slots = [];

  let current = mySqlToLocal(session.starts_at);
  const end = mySqlToLocal(session.ends_at);

  while (current.isBefore(end)) {
    const slotEnd = current.add(session.slot_duration, 'minute');

    // Don't create slots that run past the session end
    if (slotEnd.isAfter(end)) {
      break;
    }

    slots.push({
      starts_at: current,
      ends_at: slotEnd,
    });

    current = slotEnd.add(session.slot_gap || 0, 'minute');
  }

  return slots;
}

export default calculateSlots